import { render, staticRenderFns } from "./MyHabitsProgress.vue?vue&type=template&id=6378cbdc"
import script from "./MyHabitsProgress.vue?vue&type=script&lang=js"
export * from "./MyHabitsProgress.vue?vue&type=script&lang=js"
import style0 from "./MyHabitsProgress.vue?vue&type=style&index=0&id=6378cbdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports